import React from 'react';
import SEO from '../../components/SEO';
import PageBanner from '../../components/PageBanner';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../data/translations';

const bannerImages = [
    {
        image: '/assets/images/about/vision/826_1719308298vision-banner1.png',
        align: 'center'
    },
    {
        image: '/assets/images/about/vision/907_1719308372vision-banner2.png',
        align: 'left'
    },
    {
        image: '/assets/images/about/vision/446_1719308388vision-banner3.png',
        align: 'right'
    },
    {
        image: '/assets/images/about/vision/289_1719308409vision-banner4.png',
        align: 'left' // Based on image composition
    }
];

const Vision = () => {
    const { language } = useLanguage();
    const t = translations[language].vision;

    const banners = t.banners.map((banner, index) => ({
        ...banner,
        ...bannerImages[index]
    }));

    return (
        <div className="pt-20 lg:pt-[120px] bg-white">
            {/* Hero Section */}
            <SEO
                title="BAIC Vision Oman |Future Innovation & Automotive Strategy"
                description="Discover BAIC Oman's vision, future mobility, innovation, sustainable solutions."
                canonicalUrl="https://baicoman.com/about/vision"
            />
            <h1 className="sr-only">BAIC Vision Oman - Innovation, Technology & Future Mobility</h1>
            {/* Hero Section */}
            <PageBanner
                image="/assets/images/about/vision/vision-page-heading.BnDegSPW.png"
                imageAlt="BAIC Vision"
            >
                <h4 className="text-sm font-bold text-gray-300 uppercase tracking-widest mb-3">{t.subtitle}</h4>
                <h1 className="text-2xl md:text-7xl font-bold text-white uppercase tracking-tight">{t.title}</h1>
            </PageBanner>

            {/* Banner Sections */}
            {banners.map((banner, index) => (
                <div key={index} className="relative h-[400px] md:h-[500px] w-full overflow-hidden group">
                    {/* Image with zoom effect */}
                    <img
                        src={banner.image}
                        alt={banner.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    {/* Gradient Overlay for text readability */}
                    <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-500"></div>

                    {/* Content */}
                    <div className={`absolute inset-0 flex flex-col justify-center px-4 md:px-20 max-w-7xl mx-auto ${banner.align === 'center' ? 'items-center text-center' :
                        banner.align === 'right' ? 'items-end text-right' : 'items-start text-left'
                        }`}>
                        <div className="animate-in fade-in slide-in-from-bottom-4 duration-700 delay-100">
                            <h3 className="text-2xl md:text-3xl font-medium text-white mb-2 drop-shadow-lg opacity-90">{banner.subtitle}</h3>
                            <h2 className={`text-5xl md:text-6xl font-bold text-white drop-shadow-xl ${banner.title.includes('Characteristic') ? 'leading-tight max-w-2xl' : ''}`}>
                                {banner.title}
                            </h2>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Vision;
